<template>
  <div class="city_check" v-if="isShow">
    <div class="check-page-layer" :class="{fadeInRight: isShow, fadeInLeft: fadeInLeft}">
      <div class="back-layer">
        <div class="back" @click="closeCityCheck">返回</div>
        <div class="title">项目导航</div>
        <div class="all" v-if="showAll" @click="chooseCity()">查看全部</div>
      </div>

      <div class="block-layer border-bottom" v-if="hotlist.length > 0">
        <div class="block-title">热门城市</div>
        <div class="block-content">
          <div class="item" v-for="item in hotlist" @click="goPage(item)">{{item.name}}</div>
        </div>
      </div>

      <div class="block-layer border-bottom" v-for="item in areaslist">
        <!-- <div class="block-title">{{item.name}}区域</div> -->
        <div class="block-content">
          <div class="item" v-for="iitem in item.list" @click="goPage(iitem)">{{iitem.name}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import util from "@/utils/utils";
import { MessageBox } from "mint-ui";
import * as comreq from "@/utils/comreq";
import Cookies from "js-cookie";
export default {
  components: {},
  props: {
    showAll: Boolean,
    hotlist: Array,
    areaslist: Array,
    cityname: String,
    isShow: Boolean
  },
  data() {
    return {
      fadeInLeft: false
    };
  },
  watch: {},
  computed: {
    ...mapState(["isInMiniProgram"])
  },
  methods: {
    closeCityCheck() {
      let that = this;
      that.fadeInLeft = true;
      setTimeout(() => {
        that.$emit("close");
      }, 350);
      setTimeout(() => {
        that.fadeInLeft = false;
      }, 400);
    },
    // lj01
    goPage(item) {
      let that = this;
      if (item.name == that.cityname) {
        that.$emit("close");
        return;
      }
      if (item.url == "##") {
        MessageBox.alert("敬请期待");
      } else {
        if (that.showAll) {
          that.chooseCity(item);
        } else {
          that.$emit("close");
          let url = `${item.url}&miniproj=${item.minipid}&from=sysintro`;
          util.openYqRsMakeLink(url, "reLaunch");
        }
      }
    },
    chooseCity(item) {
      let that = this;
      that.fadeInLeft = true;
      let city = item ? item.name : "全部";
      setTimeout(() => {
        that.$emit("choose", city);
      }, 350);
      setTimeout(() => {
        that.fadeInLeft = false;
      }, 400);
    }
  },
  created() {},
  mounted() {}
};
</script>
<style lang="css" scoped>
.city_check {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 100;
  background-color: rgba(0, 0, 0, 0.5);
}

.check-page-layer {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: #ffffff;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.block-layer {
  width: 92%;
  margin: 0 auto;
  padding: 0.2rem 0;
}

.block-layer .block-title {
  line-height: 0.6rem;
  font-weight: bold;
  color: #333333;
  font-size: 0.32rem;
}

.block-layer .block-content {
  display: flex;
  flex-wrap: wrap;
}

.block-layer .block-content .item {
  /*width: 28%;*/
  height: 0.7rem;
  padding: 0 .2rem;
  border: 1px solid #b6b6b6;
  text-align: center;
  line-height: 0.7rem;
  border-radius: 4px;
  margin-right: 0.2rem;
  margin-top: 0.2rem;
  color: #333333;
  font-size: 0.28rem;
}

.check-page-layer.fadeInRight {
  animation: fadeInRight 0.4s;
}

.check-page-layer.fadeInLeft {
  animation: fadeInLeft 0.4s;
}

.back-layer {
  height: 1rem;
  line-height: 1rem;
  font-size: 0.32rem;
  color: #313131;
  text-align: center;
  position: relative;
}

.back-layer .back {
  position: absolute;
  left: 0.2rem;
  background: url("https://assets.rurushishi.com/yq-rs-make/sysintro/jiantou.png")
    no-repeat left 0.36rem;
  background-size: 0.24rem 0.24rem;
  line-height: 1rem;
  padding-left: 0.3rem;
  color: #666666;
  font-size: 0.28rem;
}

.back-layer .all {
  position: absolute;
  top: 0;
  right: 0.2rem;
  line-height: 1rem;
  color: #666666;
  font-size: 0.28rem;
}

@keyframes fadeInRight {
  from {
    opacity: 0;
    -webkit-transform: translate3d(100%, 0, 0);
    transform: translate3d(100%, 0, 0);
  }

  to {
    opacity: 1;
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}
@keyframes fadeInLeft {
  from {
    opacity: 0;
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }

  to {
    opacity: 1;
    -webkit-transform: translate3d(100%, 0, 0);
    transform: translate3d(100%, 0, 0);
  }
}
</style>